import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Svg from '../../../../component/common/Svg';
import '../assetes/css/style.css';

export default function DocumentationSidebar() {
    const [openSubmenu, setOpenSubmenu] = useState(null);
    const { pathname } = useLocation();
    const { t } = useTranslation();

    // Keep the submenu open if a child item is active
    useEffect(() => {
        if (pathname.startsWith('/admin/ducumentation/surveys/')) {
            setOpenSubmenu('survey');
        } else if (pathname.startsWith('/admin/ducumentation/settings/')) {
            setOpenSubmenu('settings');
        }
    }, [pathname]);

    // Toggle submenus while ensuring only one stays open at a time
    const toggleSubmenu = (menuKey) => {
        setOpenSubmenu((prev) => (prev === menuKey ? null : menuKey));
    };

    return (
        <div className="dashboard-side-menu-wrapper document-sidebar d-flex flex-column align-items-stretch">
            <nav className="dashboard-side-menu position-static">
                <ul className='top-menu'>
                    <div className='back-btn'>
                        <li><NavLink to="/admin/survey/list">
                            <Svg name="left-arrow" />
                            <span>{t('documentation.sidebar.backToSurvey')}</span>  </NavLink>
                        </li>
                    </div>

                    {/* Survey Menu */}
                    <li className="has-subnav">
                        <div
                            className="d-flex drop-wrap align-items-center"
                            onClick={() => toggleSubmenu('survey')}
                        >
                            <div className={`parent-toggle ${openSubmenu === 'survey' ? "active" : ""}`}>
                                <Svg name="survey" />
                                <span className="nav-text">{t('documentation.sidebar.survey')}</span>
                            </div>

                            {/* Toggle Button */}
                            <div className="drop-btn">
                                {openSubmenu === 'survey' ? (
                                    <Svg name="arrow-down" />
                                ) : (
                                    <Svg name="arrow-right" />
                                )}
                            </div>
                        </div>

                        {/* Submenu */}
                        <div className={`collapse ${openSubmenu === 'survey' ? 'show' : ''}`}>
                            <ul className="subnav">
                                <li><NavLink to="/admin/ducumentation/surveys/document-dashboard">{t('documentation.sidebar.surveyList')}</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-qandabuilder">{t('documentation.sidebar.qandaBuilder')}</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-formbuilder">{t('documentation.sidebar.formBuilder')}</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-reportbuilder">{t('documentation.sidebar.reportBuilder')}</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-emailtemplates">{t('documentation.sidebar.emailTemplates')}</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-variables">{t('documentation.sidebar.variables')}</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-publishshare">{t('documentation.sidebar.publishShare')}</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-integration">{t('documentation.sidebar.integration')}</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-webhook">{t('documentation.sidebar.webhooks')}</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-questionnarire">{t('documentation.sidebar.questionnaire')}</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-thankyoupage">{t('documentation.sidebar.thankYouPage')}</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-leaderasure">{t('documentation.sidebar.leadErasureRules')}</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-privacypolicy">{t('documentation.sidebar.privacyPolicy')}</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-cookiepolicy">{t('documentation.sidebar.cookiePolicy')}</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/create-survey">{t('documentation.sidebar.createSurvey')}</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-recomadation">{t('documentation.sidebar.recommendations')}</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-surveygroups">{t('documentation.sidebar.surveyGroups')}</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-surveysync">{t('documentation.sidebar.surveySync')}</NavLink></li>
                            </ul>
                        </div>
                    </li>

                    {/* Analytics */}
                    <li>
                        <div className='drop-wrap'>
                            <NavLink to="/admin/ducumentation/document-analytics">
                                <Svg name="analytics" />
                                <span className="nav-text">{t('documentation.sidebar.analytics')}</span>
                            </NavLink>
                        </div>
                    </li>

                      <li>
                        <div className='drop-wrap'>
                            <NavLink to="/admin/ducumentation/document-ActivityLogs">
                                <Svg name="analytics" />
                                <span className="nav-text">{t('documentation.sidebar.activityLog')}</span>
                            </NavLink>
                        </div>
                    </li>

                    <li>
                        <div className='drop-wrap'>
                            <NavLink to="/admin/ducumentation/document-tickets">
                                <Svg name="survey" />
                                <span className="nav-text">{t('documentation.sidebar.tickets')}</span>
                            </NavLink>
                        </div>
                    </li>


                    {/* Settings Menu */}
                    <li className="has-subnav">
                        <div
                            className="d-flex drop-wrap align-items-center"
                            onClick={() => toggleSubmenu('settings')}
                        >
                            <div className={`parent-toggle ${openSubmenu === 'settings' ? "active" : ""}`}>
                                <Svg name="settings" />
                                <span className="nav-text">{t('documentation.sidebar.settings')}</span>
                            </div>

                            {/* Toggle Button */}
                            <div className="drop-btn">
                                {openSubmenu === 'settings' ? (
                                    <Svg name="arrow-down" />
                                ) : (
                                    <Svg name="arrow-right" />
                                )}
                            </div>
                        </div>

                        {/* Submenu */}
                        <div className={`collapse ${openSubmenu === 'settings' ? 'show' : ''}`}>
                            <ul className="subnav subnav-settings">
                                <li className="subnav-section">
                                    <span className="subnav-section-title">{t('documentation.sidebar.settingsGeneral')}</span>
                                    <ul className="subnav-section-links">
                                        <li><NavLink to="/admin/ducumentation/settings/document-accountsetting">{t('documentation.sidebar.profile')}</NavLink></li>
                                        <li><NavLink to="/admin/ducumentation/settings/document-security">{t('documentation.sidebar.security')}</NavLink></li>
                                        <li><NavLink to="/admin/ducumentation/settings/document-ticket-notifications">{t('documentation.sidebar.notifications')}</NavLink></li>
                                    </ul>
                                </li>
                                <li className="subnav-section">
                                    <span className="subnav-section-title">{t('documentation.sidebar.settingsUserManagement')}</span>
                                    <ul className="subnav-section-links">
                                        <li><NavLink to="/admin/ducumentation/settings/document-users">{t('documentation.sidebar.users')}</NavLink></li>
                                        <li><NavLink to="/admin/ducumentation/settings/document-roles">{t('documentation.sidebar.roles')}</NavLink></li>
                                        <li><NavLink to="/admin/ducumentation/settings/document-teams">{t('documentation.sidebar.teams')}</NavLink></li>
                                    </ul>
                                </li>
                                <li className="subnav-section">
                                    <span className="subnav-section-title">{t('documentation.sidebar.settingsOrganizationDetails')}</span>
                                    <ul className="subnav-section-links">
                                        <li><NavLink to="/admin/ducumentation/settings/document-organization-details/privacy-policy">{t('documentation.sidebar.privacyPolicy')}</NavLink></li>
                                        <li><NavLink to="/admin/ducumentation/settings/document-organization-details/terms-of-use">{t('documentation.sidebar.termsOfUse')}</NavLink></li>
                                        <li><NavLink to="/admin/ducumentation/settings/document-organization-details/cookie-policy">{t('documentation.sidebar.cookiePolicy')}</NavLink></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </li>

                </ul>
            </nav>
        </div>
    );
}
